export function imprimirMotivoGastoDiario(motivo: string) {
    return mapaMotivoGastoDiario[motivo];
}

const mapaMotivoGastoDiario: Record<string, string> = {
    pago: 'Pago',
    adelanto: 'Adelanto',
    retiro: 'Retiro',
    sinEspecificar: 'Sin especificar',
};

export function imprimirMotivo(motivo: string) {
    return mapaMotivo[motivo];
}

const mapaMotivo: Record<string, string> = {
    'cuota': 'Cuota',
    'reposicion-material': 'Reposición de material',
    'reposicion-cuponera': 'Reposición de cuponera',
    'gasto-notarial': 'Gasto notarial',
    'abono-inicial': 'Abono incial',
    'multa': 'Multa',
    'nivelacion': 'Nivelación',
};

export function imprimirMetodoDePago(metodoDePago: string) {
    return mapaMetodoDePago[metodoDePago];
}

const mapaMetodoDePago: Record<string, string> = {
    efectivo: 'Efectivo',
    deposito: 'Depósito',
    transferencia: 'Transferencia',
    cheque: 'Cheque',
    tarjeta: 'Tarjeta',
};

export function imprimirFormaDePago(formaDePago: 'cheque' | 'pagare' | 'contado' | 'tarjeta') {
    return mapaFormaDePago[formaDePago];
}

const mapaFormaDePago = {
    cheque: 'Cheque',
    pagare: 'Pagaré',
    contado: 'Contado',
    tarjeta: 'Tarjeta',
};

export function imprimirArea(area: string) {
    return mapaArea[area];
}

const mapaArea: Record<string, string> = {
    preu: 'Preu',
    ingles: 'Inglés',
};

export function escribirMonto(monto: number) {
    const valorConPuntos = monto.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '$' + valorConPuntos;
}



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/utilidades.ts